export default __webpack_public_path__ + "static/media/ecoexpert.d7a512af.png";